// Google Tag Manager utilities
export const GTM_ID = process.env.REACT_APP_GTM_ID || 'GTM-XXXXXX';

// Initialize dataLayer
export const initializeGTM = () => {
  window.dataLayer = window.dataLayer || [];
  
  // Add GTM script to head
  const script = document.createElement('script');
  script.innerHTML = `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${GTM_ID}');
  `;
  document.head.appendChild(script);

  // Add noscript to body
  const noscript = document.createElement('noscript');
  noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${GTM_ID}"
    height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
  document.body.insertBefore(noscript, document.body.firstChild);
};

// Push event to dataLayer
export const trackEvent = (eventName, parameters = {}) => {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      event: eventName,
      ...parameters
    });
  }
};

// Track page view
export const trackPageView = (pagePath, pageTitle) => {
  trackEvent('page_view', {
    page_path: pagePath,
    page_title: pageTitle
  });
};

// Track user registration
export const trackUserRegistration = (data) => {
  trackEvent('sign_up', {
    user_type: data.userType || 'student',
    user_id: data.userId,
    method: data.method || 'email',
    event_category: 'engagement',
    event_label: `${data.userType || 'student'}_registration`,
    source: data.source || 'direct'
  });
};

// Track booking
export const trackBooking = (bookingData) => {
  trackEvent('purchase', {
    transaction_id: bookingData.bookingId,
    value: bookingData.amount,
    currency: bookingData.currency,
    items: [{
      item_id: bookingData.classId,
      item_name: bookingData.className,
      item_category: bookingData.classType,
      item_variant: bookingData.duration,
      price: bookingData.amount,
      quantity: 1
    }],
    user_type: 'student',
    teacher_id: bookingData.teacherId,
    event_category: 'ecommerce'
  });
};

// Track trial booking
export const trackTrialBooking = (trialData) => {
  trackEvent('begin_checkout', {
    currency: 'INR',
    value: 0,
    items: [{
      item_id: trialData.classId,
      item_name: 'Trial Class',
      item_category: trialData.classType,
      price: 0,
      quantity: 1
    }],
    coupon: 'TRIAL',
    event_category: 'ecommerce',
    event_label: 'trial_booking'
  });
};

// Track search
export const trackSearch = (searchTerm, searchType, resultsCount) => {
  trackEvent('search', {
    search_term: searchTerm,
    search_type: searchType,
    results_count: resultsCount,
    event_category: 'engagement'
  });
};

// Track teacher profile view
export const trackTeacherView = (teacherId, teacherName) => {
  trackEvent('view_item', {
    currency: 'INR',
    value: 0,
    items: [{
      item_id: teacherId,
      item_name: teacherName,
      item_category: 'teacher_profile'
    }],
    event_category: 'engagement'
  });
};

// Track marketing campaign
export const trackCampaign = (campaignData) => {
  trackEvent('campaign_impression', {
    campaign_name: campaignData.name,
    campaign_source: campaignData.source,
    campaign_medium: campaignData.medium,
    campaign_term: campaignData.term,
    campaign_content: campaignData.content,
    event_category: 'marketing'
  });
};

// Track custom event
export const trackCustomEvent = (category, action, label, value = null) => {
  const eventData = {
    event_category: category,
    event_action: action,
    event_label: label
  };
  
  if (value !== null) {
    eventData.value = value;
  }
  
  trackEvent('custom_event', eventData);
};

// Set user properties
export const setUserProperties = (properties) => {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      user_properties: properties
    });
  }
};

export default {
  initializeGTM,
  trackEvent,
  trackPageView,
  trackUserRegistration,
  trackBooking,
  trackTrialBooking,
  trackSearch,
  trackTeacherView,
  trackCampaign,
  trackCustomEvent,
  setUserProperties
};